module.exports = __webpack_public_path__ + "static/media/dark_samus.4ceeb2e7.png";